/**
 * Режимы блока «Подписанты» для КНМ/ПМ (корневой block, без parentName).
 * По ТЗ 4.1.6 (лист «будет», Основные сведения).
 */
export enum RootSignersModeEnum {
  /** Кнопка «Добавить» скрыта; один signer авто; редактирование первой записи доступно */
  SINGLE_AUTO = 'SINGLE_AUTO',
  /** Кнопка доступна; первая запись только чтение; новые можно добавлять и редактировать */
  MULTI_FIRST_LOCKED = 'MULTI_FIRST_LOCKED',
  /** Кнопка видна и disabled; записи не редактируются */
  READONLY_ALL = 'READONLY_ALL',
}
